import { useQuery } from '@tanstack/react-query';
import { queryFn, getQueryKey } from './queryFn';
import type { Period } from '@utilities/timeSeriesPeriodMap';

export type Params = {
  canonicalUrl: string;
  period?: Period;
};

/**
 * ### Description
 *
 * This hook returns a CompanyTimeSeries data subset defined in https://studio.apollographql.com/graph/Simply-Wall-St-5peegj/variant/prod/schema/reference/objects/CompanyTimeSeries
 *
 * ### Arguments
 * ```
 * type Params = {
 *   canonicalUrl: string;
 *   period: Period;
 * };
 * ```
 *
 */

export const useCompanyTimeSeries = ({
  canonicalUrl,
  period = '1Y',
}: Params) => {
  return useQuery({
    queryKey: getQueryKey({ canonicalUrl, period }),
    queryFn,
    staleTime: 3600000,
    enabled: !!canonicalUrl && !!period,
  });
};
